export const formatSearchCount = (count: number): string => {
  return count >= 10000 ? `9999+` : `${count}`;
};
